import { render, staticRenderFns } from "./RepairRegistrationReportDS.vue?vue&type=template&id=8c8b0522&scoped=true&"
import script from "./RepairRegistrationReportDS.vue?vue&type=script&lang=js&"
export * from "./RepairRegistrationReportDS.vue?vue&type=script&lang=js&"
import style0 from "./RepairRegistrationReportDS.vue?vue&type=style&index=0&id=8c8b0522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c8b0522",
  null
  
)

export default component.exports